import { CSSProperties, FunctionComponent, PropsWithChildren } from "react";
import { cx, css } from "@adjust/libs/emotion";

const blockCSS = css({
  ["& + &"]: {
    marginTop: "2em",
  },
});

const fontFamily = css({
  fontFamily: "DM Sans,sans-serif",
});

const fontCSS = css({
  fontSize: "20px",
});

type ParagraphProps = {
  type: "paragraph" | "heading-one" | "heading-two" | "list-item" | "numbered-list" | "bulleted-list" | "blockquote" | "blockquote-footer";
  textAlign?: CSSProperties["textAlign"];
  fontSize?: CSSProperties["fontSize"];
  fontFamily?: CSSProperties["fontFamily"];
};

const Typography: FunctionComponent<PropsWithChildren<ParagraphProps>> = ({ children, type, ...props }) => {
  const modifiedCSS = css(props);
  switch (type) {
    case "blockquote":
      return <blockquote className={cx(blockCSS, fontCSS, fontFamily, modifiedCSS, "blockquote")}>{children}</blockquote>;
    case "blockquote-footer":
      return <footer className={cx(blockCSS, fontCSS, fontFamily, modifiedCSS, "blockquote-footer")}>{children}</footer>;
    case "bulleted-list":
      return <ul className={cx(blockCSS, fontCSS, fontFamily, modifiedCSS)}>{children}</ul>;
    case "heading-one":
      return <h1 className={cx(blockCSS, fontFamily, modifiedCSS)}>{children}</h1>;
    case "heading-two":
      return <h2 className={cx(blockCSS, fontFamily, modifiedCSS)}>{children}</h2>;
    case "list-item":
      return <li className={cx(blockCSS, fontCSS, fontFamily, modifiedCSS)}>{children}</li>;
    case "numbered-list":
      return <ol className={cx(blockCSS, fontCSS, fontFamily, modifiedCSS)}>{children}</ol>;
    case "paragraph":
      return <p className={cx(blockCSS, fontCSS, fontFamily, modifiedCSS)}>{children}</p>;
    default:
      return <span className={cx(blockCSS, fontCSS, fontFamily, modifiedCSS)}>{children}</span>;
  }
};

export default Typography;
